import {Icon} from '@/components/atoms'
import PropTypes from 'prop-types'

/**
 * InfoOrError component displays either an informational message or an error message based on the provided props.
 *
 * @param {Object} props - The component props.
 * @param {string} [props.info] - The informational message to display.
 * @param {string} [props.error] - The error message to display.
 * @param {string} props.id - The unique identifier for the component, used for testing purposes.
 * @returns {JSX.Element|null} The rendered component or null if neither info nor error is provided.
 */
const InfoOrError = ({info, error, id}) => {
  const hasInfoOrError = info || error

  if (!hasInfoOrError) {
    return null
  }

  return (
    <div className="flex items-start justify-between">
      {info && !error && (
        <span className="flex items-start gap-1" data-testid={`${id}-info-msg`}>
          <Icon icon="info" size="small" className="!text-xs" />
          <p className={'text-xs text-text-secondary'}>{info}</p>
        </span>
      )}
      {error && (
        <span className="flex items-start gap-1" data-testid={`${id}-error-msg`} data-cy={`${id}-error-msg`}>
          <Icon icon="error_outline" size="small" className="!text-xs text-support-error-primary" />
          <p className={'text-xs text-support-error-primary'}>{error}</p>
        </span>
      )}
    </div>
  )
}

InfoOrError.propTypes = {
  info: PropTypes.string,
  error: PropTypes.string,
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}

export default InfoOrError
